import { ArrowLeftOutlined } from "@ant-design/icons";
import { Space, Typography } from "antd";
import { FC } from "react";
import { useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router";
import { useMediaQuery } from "src/components/FinaLayout/hooks/hooks";

interface CardTitleProps {
    title: string,
    /** Where to go when we did not push this screen ourselves — the security
     * details page is opened in a new tab, so there is nothing to go back to. */
    redirectUrl: string
}

const CardTitle: FC<CardTitleProps> = (props) => {
    const isMobile = useMediaQuery("(max-width: 450px)");
    const history = useHistory();
    const location = useLocation<{ cameFromApp?: boolean } | undefined>();

    const { title, redirectUrl } = props
    const { Title } = Typography

    const queryClient = useQueryClient()

    return (
        <Space style={{ display: "flex", alignItems: "stretch" }}>
            <ArrowLeftOutlined
                onClick={() => {
                    queryClient.invalidateQueries({ queryKey: ['getWatchlists'] })
                    // Pushing redirectUrl unconditionally sent everyone to the
                    // dashboard, even when they arrived from the security they
                    // were looking at. Screens that push here say so in the
                    // location state; anything else still gets the fallback.
                    if (location.state?.cameFromApp) history.goBack()
                    else history.push(redirectUrl)
                }}
                style={{ paddingRight: "0.5em", cursor: "pointer" }}
            />
            {!isMobile &&
                <Title level={4} style={{ margin: 0 }}>
                    {title}
                </Title>
            }
        </Space>
    );
};

export default CardTitle;